import GetProfessionByIdRequestModelBase from '../_generated/modelBases/get-profession-by-id-request-model-base';

export default class GetProfessionByIdRequestModel extends GetProfessionByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
